import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import img1 from "../assets/img/blogs/img1.jpeg";


import blog3 from '../assets/img/blogs/blog3.jpeg'
import blog2 from '../assets/img/blogs/blog2.png'

import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Framework of Javascript",
      description: "React Vs Angular. What is Better and Why?",
      imgUrl: blog2,
      link: 'https://medium.com/@Isha_/angular-vs-react-what-to-choose-and-why-f960d53bb373'
    },

    {
      title: "ES6",
      description: "Use of Let, Var and Const. When should we use that",
      imgUrl: img1,
      link: 'https://blog.devgenius.io/let-var-and-const-in-js-2f6226457d2f'
    },
    {
      title: "Tech Blogs",
      description: "Blogs related to Js, React, HTML and Css",
      imgUrl: blog3,
      link: 'https://medium.com/@Isha_/learn-the-basic-fundamental-concepts-of-programming-2abd16f28c54'
    },
  
  
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div
              //  className={isVisible ? "animate__animated animate__fadeIn": ""}
             >
                <h2>Tech Blogs</h2>
                <p>I like sharing content related to the stuff that I have learned over the years in Web Development so it can help other people on Tech platforms and <a rel="noreferrer noopener" target='_blank' href="https://medium.com/@Isha_" style={{ color: 'blueviolet' }}>Medium</a>.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  {/* <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav> */}
                  <Tab.Content id="slideInUp" 
                  // className={isVisible ? "animate__animated animate__slideInUp" : ""}
               
                 >
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
